import { externallyManagedNotice$ } from 'externallyManaged/externallyManagedNotice$';
import { dispatchAction, connect } from '@ardoq/rxbeach';
import { setExternallyManagedNoticeSuppressed } from 'externallyManaged/actions';
import { PayloadIsSuppressed } from 'externallyManaged/types';
import { Checkbox } from '@ardoq/forms';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { t, type WithI18nLocale } from '@ardoq/i18n';
import { combineLatest, map } from 'rxjs';

type SuppressExternallyManagedNoticeProps = PayloadIsSuppressed &
  WithI18nLocale;

const SuppressExternallyManagedNoticeBase = ({
  isSuppressed,
  i18nLocale,
}: SuppressExternallyManagedNoticeProps) => {
  return (
    <Checkbox
      isChecked={Boolean(isSuppressed)}
      onChange={() =>
        dispatchAction(
          setExternallyManagedNoticeSuppressed({
            isSuppressed: !isSuppressed,
          })
        )
      }
    >
      {t(
        i18nLocale,
        'externallyManaged:suppressNoticeCheckbox',
        'Don’t show me this message again'
      )}
    </Checkbox>
  );
};

const suppressExternallyManagedNoticeViewModel$ = combineLatest([
  externallyManagedNotice$,
  i18nLocale$,
]).pipe(
  map(([state, i18nLocale]): SuppressExternallyManagedNoticeProps => ({
    ...state,
    i18nLocale,
  }))
);

export const SuppressExternallyManagedNotice = connect(
  SuppressExternallyManagedNoticeBase,
  suppressExternallyManagedNoticeViewModel$
);
